import { render, staticRenderFns } from "./approve_detail.vue?vue&type=template&id=5fa0105c&scoped=true&"
import script from "./approve_detail.vue?vue&type=script&lang=js&"
export * from "./approve_detail.vue?vue&type=script&lang=js&"
import style0 from "./approve_detail.vue?vue&type=style&index=0&id=5fa0105c&lang=less&scoped=true&"
import style1 from "./approve_detail.vue?vue&type=style&index=1&id=5fa0105c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa0105c",
  null
  
)

export default component.exports